<template>
  <div :ref="`question-item-${question.id}`" :class="'question__item' + ((examState.question == question.id) ? ' question__item--active' : '')">
    <div class="question__item__index">{{ question.number }}</div>
    <component :is="questionTemplate" :question="question" :editable="editable" :response="response ? response : {answer: '', answer_id: -1}" v-on:selectAnswer="selectAnswer"></component>
    <ExplainQuestion :explain="question.explain" v-show="isExplain"></ExplainQuestion>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { STORE_KEY } from '../_store/constants'
import QuestionReadingBoolean   from './questions/QuestionReadingBoolean'
import QuestionReadingSelect    from './questions/QuestionReadingSelect'
import QuestionReadingText      from './questions/QuestionReadingText'
import QuestionListeningAudio  from './questions/QuestionListeningAudio'
import QuestionListeningSelect  from './questions/QuestionListeningSelect'
import QuestionListeningImage   from './questions/QuestionListeningImage'
import QuestionListeningSpell   from './questions/QuestionListeningSpell'
import QuestionWritingText      from './questions/QuestionWritingText'
import QuestionWritingContent   from './questions/QuestionWritingContent'
import QuestionWritingSort      from './questions/QuestionWritingSort'
import ExplainQuestion from './ExplainQuestion'

export default {
  name: 'QuestionSingle',
  props: {
    question: Object,
    parent: Object,
    response: Object,
    editable: Boolean,
    isExplain: {
      type: Boolean,
      default: false
    }
  },
  components: {
    QuestionReadingBoolean,
    QuestionReadingSelect,
    QuestionReadingText,
    QuestionListeningAudio,
    QuestionListeningSelect,
    QuestionListeningImage,
    QuestionListeningSpell,
    QuestionWritingText,
    QuestionWritingContent,
    QuestionWritingSort,
    ExplainQuestion
  },
  computed: {
    ...mapGetters({
      examState: `${STORE_KEY}/examState`,
    }),
    questionTemplate() {
      switch (this.question.type) {
        // Reading
        case 101:
          return 'QuestionReadingBoolean'
        
        case 102:
          return 'QuestionReadingSelect'
        
        case 106:
          return 'QuestionReadingText'
        
        // Listening
        case 151:
          return 'QuestionListeningSelect'

        case 152:
          if (this.parent && this.parent.type == 110) {
            return 'QuestionReadingText'
          }
          return 'QuestionListeningSpell'

        case 153:
          return 'QuestionListeningImage'

        case 154:
          return 'QuestionListeningImage'

        case 156:
          return 'QuestionListeningAudio'

        // Writing
        case 173:
          return 'QuestionWritingText'

        case 174:
          return 'QuestionWritingContent'

        case 176:
          return 'QuestionWritingSort'
      
        default:
          return 'QuestionReadingBoolean'
      }
    }
  },
  methods: {
    selectAnswer(dataAnswer) {
      this.$emit('selectAnswer', dataAnswer)
    }
  },
  mounted() {
    var div = document.createElement("div")
    div.innerHTML = this.question.content

    if (!div.innerText.trim()) {
      this.question.content = null
    }
  },
  beforeMount() {
    if(this.parent !== null && this.parent.children) {
      this.question.selectOption = this.parent.children.map((item, index) => {
        return {
          index: index,
          value: String.fromCharCode( 65 + index)
        }
      })
    }
  }
}
</script>